import { AxiosRequestConfig } from 'axios';
import { getWorkspace } from '@utils/store';
import { components } from '@src/types/generated/api';
import { http } from './base-http';

interface Response {
  data: components['schemas']['UploadFileResponse'];
}
interface UploadConfig extends AxiosRequestConfig {
  onProgress?: (_: number) => void;
}

export const uploadFilesApi = <T = Response>(
  payload: any,
  config: UploadConfig,
  path: string = 'files',
  workspace: string = getWorkspace(),
): Promise<T> => {
  const { onProgress, ...options } = config;
  return http.post(`/api/v1/workspaces/${workspace}/${path}`, payload, {
    ...options,
    onUploadProgress: ({ progress = 1 }) => {
      const percentCompleted = Math.round(progress * 100);
      onProgress?.(percentCompleted);
    },
  });
};
